export default __webpack_public_path__ + "static/media/pantry1-afterI-1024w.a9db938a.avif";